import { RouteProps } from "react-router";
import { connect } from "react-redux";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";
// import * as actions from "src/bepaid/store/model/Fetch/actions";
import * as formActions from "src/ipm-shared/components/Form/actions";

import Component from "./View";

const mapStateToProps = (state: RootState) => ({
  accountProfile: selectors.getCurrentAccountProfile(state),
  accountCurrencyId: selectors.getAccountCurrencyId(state),
  countryCode: selectors.getAccountCountryCode(state),
  currentCompany: selectors.getCompany(state)
});

const mapDispatchToProps = {
  setControl: formActions.setControl
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
